<template>
    <div class="card col-md-12 mx-auto">
        <div class="card-header card-header bg-primary text-white h4 m-0">
            <page-title :title="($t(titleKey))"></page-title>
        </div>


        <div class="card-body" v-if="hasItems" v-cloak>
            <div class="alert alert-info m-2" role="alert">
                <span>{{ $t('claims.eventClaimsInfo')}}</span>
            </div>
            <div v-cloak>
                <div class="input-group col-sm-3 float-right">
                    <div class="input-group-addon fa fa-search" style="display:table-cell"></div>
                    <input class="form-control fa fa-search" name="query" v-model="searchQuery">
                </div>
            </div>
            <custom-grid ref="rolesGrid"
                         :data="roles"
                         :columns="gridColumns"
                         :filter-key="searchQuery"
                         :captions="gridCaptions"
                         :usedForRelatedForms="false"
                         :btns="btns">
            </custom-grid>
        </div>
        <div class="card-body" v-else v-cloak>
            <div class="alert alert-warning" role="alert">
                <h4>
                    Липсват данни.
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomGrid from "../../../components/grid/CustomGrid";
    import PageTitle from '../../../components/common/PageTitle';

    export default {
        components: {
            CustomGrid,
            PageTitle,
        },
        props: {

        },
        data() {
            return {
                componentName: "RolesList",
                titleKey: 'claims.evenatClaimsAdministration', // Трабва на конпонентата за бутоните за дашборд настройките
                loading: false,
                showEdit: false,
                gridCaptions: {
                    name: 'aspNetRole.name',
                    description: 'aspNetRole.description'
                },
                gridColumns: ['name', 'description'],
                roles: [{
                    id: '',
                    name: '',
                    normalizedName: '',
                    description: ''
                }],
                searchQuery: '',
                btns: [
                    {
                        name: "claimEdit",
                        text: "",
                        tooltip: this.$t('buttons.claimEdit.btnText'),
                        class: 'btn btn-primary',
                        icon: "fas fa-shield-alt",
                        show: true,
                        clickHandler: this.claimsEditBtnClick
                    }
                ]
            };
        },
        methods: {
            loadData: function () {
                if (!this.hasReadRights) {
                    this.$vs.notify({
                        title: '',
                        text: this.$t('insufficientRights'),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration,
                    });

                    return;
                }

                this.loading = true;

                return this.$http.get('/api/ParticipantsClaims/list'
                    ).then((response) => {
                        this.roles = response.data.roles;
                        this.loading = false;
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })

                        this.loading = false;
                    });
            },
            claimsEditBtnClick(args) {
                if (!this.hasClaimEditRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                this.$router.push(`/administration/participantsClaims/edit/${args.id}`);
            }
        },
        mounted: function () {
            if (!this.hasReadRights) {
                this.$router.push(`/unauthorized`);
                return;
            }

            this.loadData();

            let container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            hasItems() {
                return Array.isArray(this.roles) && this.roles.length;
            },
            hasReadRights() {
                return this.$store.getters.claims.claimsAdministration.read;
            },
            hasClaimEditRights() {
                return this.$store.getters.claims.claimsAdministration.update;
            }
        }
    }
</script>

<style scoped>
</style>
